import * as React from "react"
import {useEffect} from "react"
import {useSignal} from "@preact/signals-react";
import {Grid} from "@mui/material";
import {AutocompleteAjaxSeeker, TextFieldSeeker} from "@ui-seeker/core";

import {BACKEND_APIS} from "@constants";


export default function MatchersSKUsOptionsFilters({ brandID, lineID, onChangeLine, searchText, onInputChange }) {
	const localValue = useSignal('')

	useEffect(() => {
		localValue.value = searchText
	}, [searchText])

	return <Grid container spacing={2}>
		<Grid item xs={6}>
			<AutocompleteAjaxSeeker
				label="Line"
				urlAjax={`${BACKEND_APIS.MATCHERS}/selectors/line-options/${brandID}`}
				value={lineID}
				onChange={e => onChangeLine(e.target.value)}
			/>
		</Grid>

		<Grid item xs={6}>
			<TextFieldSeeker
				label="Search"
				helperText="press enter to search"
				startIcon="search"
				value={localValue.value}
				onChange={e => localValue.value = e.target.value}
				onKeyPress={(event) => {
					if (event.key === "Enter")
						onInputChange(localValue.value)
				}}
			/>
		</Grid>
	</Grid>
}